export default {
  banner: {
    title: "云原生身份平台",
    subtitle:
      "“云原生是 Authing 秉持的计算哲学的落地之术，采用这种架构，会持续变革软件行业的生产力。”",
    character: "—— 谢扬 · Authing CEO",
  },
  "side-content": {
    item1: "云原生 & 云原生应用",
    item2: "从云计算到云原生",
    item3: "Authing 身份云以开发者为中心",
    item4: "公有云基础设施",
    item5: "Kubernetes",
    item6: "云中立",
  },
  item1: {
    title: "什么是云原生，如何构建云原生应用",
    content1:
      "云原生是一种利用云计算交互模型的优势来构建和运行应用程序的方法，用于帮助企业快速，持续，可靠，规模化地交付业务软件。",
    content2: "一句话解释：云原生应用就是为了在云上运行而开发的应用。",
    cardData: {
      0: {
        title: "容器化",
        content:
          "容器是一种计算单元，作为应用的包装形式，赋予应用独立和便携的能力。",
      },
      1: {
        title: "持续交付",
        content: "利用容器的轻便的特性，构建持续集成和持续发布的流水线。",
      },
      2: {
        title: "DevOps",
        content:
          "DevOps 是指开发者、测试、生产过程流水线化，以此减少应用由于依赖关系配置错误等导致的意外。",
      },
      3: {
        title: "微服务",
        content:
          "微服务是指系统的不同单元或功能运行不同的容器，每一个服务的容器数量可以根据自己的负载进行调整。",
      },
    },
  },
  item2: {
    title: "从云计算到云原生",
    content:
      "为了解决传统应用升级缓慢、架构臃肿、不能快速迭代、故障不能快速定位、问题无法快速解决等问题，云原生这一概念横空出世，它是云计算的一个必然导向，它的意义在于让云成为云化战略成功的基石，而不是阻碍。云原生可以：",
    liData: {
      0: "改进应用开发的效率",
      1: "改变企业的组织结构",
      2: "影响一个公司的决策",
    },
    img: "//files.authing.co/authing-website/cloud-native-timeline.png",
  },
  item3: {
    title: "Authing 身份云以开发者为中心",
    subTitle1: "公有云基础设施",
    subContent1:
      "Authing 的基础设施全部在云上，腾讯云、AWS、阿里云都有使用，目前核心业务我们是架构在 AWS 上，AWS的组件组合起来给我们提供了一套高效稳定的基础设施平台。",
    subTitle2: "Kubernetes",
    subContent2:
      "Authing 采用 Kubernetes 容器化技术，同时支持公共云、混合云和私有云部署，支持分钟级别弹性扩容，最大可支持亿级别用户认证访问场景。",
    subContentImg2:
      "https://authing-files.oss-cn-zhangjiakou.aliyuncs.com/authing-website/Kubernetes.png",
    subTitle3: "云中立",
    subContent3:
      "我们不能改变用户已有的云基础设施，我们只能最大程度去兼容用户的云环境。因此，我们提出了「云中立」和「Authing Inside」的概念。在多云环境下 Authing 应该保持其中立的特性，在混合云或者私有云环境下，Authing 像 Intel 一样被集成在客户的 IT 系统中。",
    subContentImg3:
      "https://authing-files.oss-cn-zhangjiakou.aliyuncs.com/authing-website/cloud-center.png",
    subContent4:
      "Authing 在云原生方面积累了非常多的经验，同时也十分重视并愿意助力客户企业对云计算技术的应用，帮助客户构建企业级云原生平台。云技术革命蕴藏着无限潜力，Authing 将始终深耕身份基础设施，为企业和开发者提供完善安全的用户认证和访问管理服务，提供单点登录 SSO ，云原生身份平台，云原生身份管理，统一身份认证平台 。",
  },
};
